import { render, staticRenderFns } from "./Sublinks.vue?vue&type=template&id=53386b4f&scoped=true"
import script from "./Sublinks.vue?vue&type=script&lang=js"
export * from "./Sublinks.vue?vue&type=script&lang=js"
import style0 from "./Sublinks.vue?vue&type=style&index=0&id=53386b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53386b4f",
  null
  
)

export default component.exports